const registerUserDictES = {
  referralUsername: "Nombre de usuario del referidor",
  nameOfUserRefferalCodeInvalid: "Nombre de usuario del referidor inválido.",
  doYouHave: "Tienes un referidor?",
  iHaveReferral: "Tengo un referidor",
  yes: "Sí",
  no: "No",
  voucher: "Código del voucher",
  doYouHaveVoucher: "Tienes un voucher?",
  username: "Nombre de usuário",
  password: "Contraseña",
  confirmPassword: "Confirmar contraseña",
  fullName: "Nombre completo",
  firstName: "Nombre",
  surname: "Apellido",
  documentNumber: "RFC",
  selectCurrency: "Seleccione una moneda",
  terms: "Yo acepto los termos y condiciones.",
  marketingEmail: "Recibir correos electrónicos sobre actualizaciones y promociones?",
  recaptcha: "Volver y verificar ReCaptcha",
  signUp: "Registrar",
  proceedToPayment: "Proceder al Pago",
  payWithExtracoin: "Pagar con extracoin",
  coupon: "Cupón de registro",
  iHaveInviteCoupon: "Tengo un cupón de invitación",
  enterInviteCoupon: "Introduce el código del cupón de invitación",
  inviteCouponRequired: "Introduce el código del cupón de invitación.",
  uploadDocPic: "Cargar foto del documento",
  on: "en",
  salePromoterRefExplanation:
    "Sólo se puede registrar como Promoter mediante un link de referencia de una Manager.",
  // toast
  referralUserNotFound: "Usuario referidor no encontrado.",
  invalidCoupon: "Cupón de crédito inválido.",
  couponDoesNotBelong: "El cupón no pertenece a este usuario referidor.",
  genericError: "Ocurrió un error. Por favor, inténtelo de nuevo.",
  passwordMin8: "La contraseña debe tener al menos 8 caracteres.",
  pleaseReverify: "Por favor, complete la verificación ReCAPTCHA.",
  paymentCheckout: "Pago",
  phoneConfirmation: "Confirmación por teléfono",
  phoneConfirmCodeExplanationPt1: "Enviamos un mensaje vía SMS para",
  phoneConfirmCodeExplanationPt2:
    "con su código de confirmación, por favor introduzca el código abajo para finalizar su registro.",
  phoneConfirmCode: "Código de confirmación",
  pleaseUploadDocPic: "Cargue una foto de su documento de identificación",
  shippingRules: "Aviso: ¡Aún no es posible usar la cotización de envío!",
  shippingRulesExplanation:
    "¡Nuestro servicio de envíos está disponible sólo para usuarios que remiten de direcciones en Italia!",
  iKnow: "Estoy consciente",
  alreadyHaveAccount: "Ya tienes una cuenta?",
  emailCanBeSpam: "Revise su carpeta de spam, el correo puede estar allí.",
  doubts: "Dudas?",
  payNow: "Pagar ahora",
  doLogin: "Iniciar sesión",
  termsAndConditions: "Términos y condiciones",
  createFreeAccount: "Crear cuenta gratuita",
  youAreRegistering: "Te estás registrando como",
  createAccount: "Crear cuenta",
  registrationSuccessActivateYourAccount:
    "¡Registro exitoso! Por favor, revisa tu correo electrónico para activar tu cuenta.",
  loginAndContinuePurchase: "Inicia sesión y continúa tu compra",
  customerRegisterTitle: "Comienza a ganar más con lo que ya compras.",
  customerRegisterDescription:
    "Como Cliente Extraconomy, cada compra puede volver a ti en forma de Extracréditos, un crédito complementario que usas como parte del pago dentro de la plataforma.",
  customerRegisterSubtitle: "Recibe Extracréditos siempre que compres en socios de Extraconomy.",
  registerRoleCustomer: "CUSTOMER",
  registerRoleStore: "STORE",
  registerRoleManager: "MANAGER",
  registerRoleManagerAssociation: "MANAGER ASSOCIATION",
  registerRolePartner: "PARTNER",
  registerRoleSeller: "SELLER",
  registerRolePromoter: "PROMOTER",
  managerRegisterTitle: "Expande tu influencia como Manager.",
  managerRegisterDescription:
    "Como Manager, construyes y lideras una red de negocios, conectando personas y empresas en una economía colaborativa.",
  managerRegisterSubtitle: "Lidera. Conecta. Transforma tu región.",
  managerRegisterSubtitleAssociation:
    "Te estás registrando como Manager Association. Sube el documento de la asociación para completar el registro.",
  associationPdfLabel: "Documento de la asociación (PDF)",
  associationPdfRequired: "Sube el documento PDF de la asociación para continuar.",
  associationPdfInvalidType: "El archivo debe ser un PDF.",
  associationPdfTooLarge: "El archivo PDF debe tener un máximo de 10 MB.",
  removeFile: "Eliminar",
  storeRegisterTitle: "Lleva tu tienda física al mundo digital con Extraconomy.",
  storeRegisterDescription:
    "El registro Store es gratuito y te prepara para activar ventas en línea con el plan Start Seller cuando quieras.",
  storeRegisterSubtitle: "Crea tu cuenta Store y evoluciona para vender en el marketplace a tu ritmo.",
  promoterRegisterTitle1: "Sé un Promotor.",
  promoterRegisterTitle2: "Conecta, Crece, Transforma.",
  promoterRegisterDescription:
    "En Extraconomy, cada conexión cuenta. Ofrece consultoría, conecta empresas, genera oportunidades y construye una economía colaborativa que valora a las personas y resultados sostenibles.",
  promoterRegisterSubtitle: "Construye impacto. Genera valor. Sé parte del cambio.",
  partnerRegisterTitle: "Sé Partner. Comparte, Crece, Valoriza.",
  partnerRegisterDescription:
    "Únete a la red de Extraconomy dedicada a los profesionales. Crea tu vitrina digital, promueve tus servicios comerciales y construye conexiones de valor que transforman el networking en oportunidades concretas e ingresos compartidos.",
  partnerRegisterSubtitle: "Crea red. Desarrolla tu negocio. Sé parte del cambio.",
  sellerRegisterTitle: "Lanza tu e-commerce en Extraconomy. Vender, Escalar, Digitalizar.",
  sellerRegisterDescription:
    "Únete a la red digital diseñada para quienes venden online. Activa tu plataforma de e-commerce, gestiona tus productos con total autonomía y aumenta tus ventas hacia nuevos mercados con comisiones justas y competitivas.",
  sellerRegisterSubtitle: "Vende a cualquier lugar. Maximiza tus ganancias. Sé parte del cambio.",
  registerSEODescription:
    "Regístrate en Extraconomy para acceder a tu cuenta, expandir tu red y aprovechar oportunidades exclusivas de negocios.",
  createYourAccount: "Crea tu cuenta",
};

export default registerUserDictES;
